export default {
    purchase: 'Acquisto',
    coupon: 'Codice di sconto',
    login_capital_letters: 'Accedi',
    login_capital_letters1: 'Accedi',
    received: 'Ricevuti',
    subscribe_capital_letters: 'Iscriviti',
    birthday_placeholder: 'GG / MM / AA',
    shop_capital_letters: 'Acquista',
    shop: 'Fare La Spesa',
    ecoflow_benefits: 'Benefici di EcoCredits',
    complete_profile: 'Completa il profilo',
    referral: 'Invita I Tuoi Amici',
    referral_desc: 'Guadagna EcoCredits per ogni amico che si iscrive con successo.',
    referral_btn: 'Unisciti ora',
    warranty: 'Garanzia',
    points_activity_a: 'La Mia Attività',
    points_tab_name: "EcoCredits d'Attività",
    rewards_tab_name: "Pemi d'Attività",
    coupon_used_desc: 'Usa questo codice alla cassa per riscattare il tuo buono regalo di {amont}.',
    email_address: 'Indirizzo e-mail',
    give_away: 'Omaggio',
    subscribe: 'Iscriviti',
    welcome_top_bar: 'Settimana degli EcoCredits x Xmas.\n Compra Ora >>',
    welcome_title: 'Ciao {username}',
    welcome_sub_title: 'Benvenuti nel programma di ricompensa EcoCredits.',
    profile: 'Profilo',
    status: 'Stato',
    refund: 'Rimborso',
    points_balance: 'Saldo dei EcoCredits',
    points_progress_tips: 'EcoCredits necessari per raggiungere il livello di {plus}: {points} EcoCredits',
    available: 'Disponibili',
    sign_up_text: "500 EcoCredits all'iscrizione",
    redeemed_succ: 'Riscattato correttamente!',
    current_tier: 'Livello attuale',
    subscribe_now: 'Iscriviti ora',
    date: 'Data',
    used: 'Utilizzati',
    edeemed_rewards_note: 'Le tue ricompense riscattate saranno visualizzate qui.',
    warranty_capital_letters: 'Garanzia',
    days_rules2: 'Valido dal {data}.',
    redeem_now: 'RISCATTA ORA',
    product_rules: 'Solo per {product}',
    membership_includes: "L'ISCRIZIONE INCLUDE",
    browse_ecocredits_rewards: 'Sfoglia le ricompense EcoCredits',
    discount: 'Sconto',
    view_more: 'Vedi di più',
    profile_desc1: 'Guadagna fino a 1000 EcoCredits completando il tuo profilo.',
    profile_desc2: 'Ottieni fino a 1000 EcoCredits per aggiungere i tuoi dati.',
    points_capital_letters: 'EcoCredits',
    history_note:
        "I tuoi EcoCredits d'attività apparanno qui. Non vedi ancora i tuoi EcoCredits d'attività? I tuoi EcoCredits d'attività veranno aggiornata entro 24 ore.",
    lucky_flop_start: 'Unisciti ora',
    lucky_flop_congrat: 'Congratulazioni',
    lucky_flop_get: 'Richiedi',
    lucky_flop_open: 'SCOPRI',
    rules: 'Regole',
    completed_text: 'Hai già ottenuto questa ricompensa.',
    redeemed: 'Riscattate',
    birthday: 'COMPLEANNO',
    summary_text: 'Panoramica del tuo account EcoCredits',
    deducted: 'Detratto',
    site_rules: 'Solo per il negozio italiana.',
    subscribe_hover: "Guadagna 500 EcoCredits all'iscrizione.",
    subscribe_text: 'Iscriviti alla newsletter EcoFlow.',
    store: 'Acquista ora',
    membership: 'MEMBERO',
    join_now: 'ISCRIVITI',
    gift_card: 'Buono regalo',
    rewards_redeemed: 'Premi',
    redeedmed_tab_name: 'Riscattato',
    issued_tab_name: 'Emessi',
    expired: 'Scaduti',
    login: 'ACCEDI',
    earn_points_title: 'Come guadagnare EcoCredits',
    have_points: 'Hai <code>{points} EcoCredits</code>',
    view_all: 'Visualizza tutti',
    add_your_birthday: 'Aggiungi il compleanno',
    earn_point_rule_shop: 'Ottieni 1 EcoCredits per ogni euro speso.',
    off: 'OFF',
    earn_point_by_order: 'Guadagna EcoCredits con ogni ordine.',
    registered: 'Registrati',
    birthday_desc2: 'Guadagna {points} EcoCredits aggiungendo la data del tuo compleanno.',
    sign_up_desc_h: 'Crea un account e ricevi 500 EcoCredits.',
    birthday_desc1: 'Aggiungi la data del tuo compleanno per ricevere EcoCredits.',
    or_text: 'OPPURE',
    profile_a: 'Profilo',
    days_rules: 'Valido per {days} giorni dal riscatto',
    join_title: 'Partecipa al programma di ricompense EcoCredits',
    pending: 'In sospeso',
    coming_soon: 'In arrivo',
    shop_to_earn_points: 'Acquista per guadagnare EcoCredits.',
    action: 'Azione',
    rewards_title: 'Premi',
    question_title: 'Fai il quiz',
    type_title: 'Tipo',
    discount_type: 'Sconto',
    already_member: 'Sei già iscritto/a?',
    already_member1: 'Sei già iscritto/a?',
    points_activity: 'ATTIVITÀ EcoCredits',
    use_this_code_note: 'Usa questo codice alla cassa per riscattare il tuo buono regalo di <PI1/>.',
    warranty_desc2: 'Ottieni1000 EcoCredits quando registri un prodotto.',
    warranty_desc1: '1000 EcoCredits per la registrazione del tuo prodotto',
    redeem_ecocredits_title: 'Riscatta i premi',
    redeem_ecocredits_title_next: "Sono disponibili premi e sconti sui nuoi prodotti da riscattare. Non perderti l'occasione!",
    member_exclusive: 'Prezzi esclusivi per i soci',
    redeem_ecocredits_subtitle_next: '¡Regístrate ahora y obtén accesorios para el Kit solar para balcones canjeando un 50 % menos de EcoCredits!',
    redeem_ecocredits_rules_title1: 'Introduzione dell’evento:',
    redeem_ecocredits_rules_title2: 'Meccanismo dell’evento:',
    redeem_ecocredits_rules_desc1:
        'Partecipa ai nostri eventi pop-up di sconto Riscatta le ricompense EcoCredits, tra il 20 e il 23 Ottobre 2023. I pop-up appariranno in modo casuale in quei giorni!',
    redeem_ecocredits_rules_desc2:
        '1. Scarta la sorpresa per primo: Iscriviti e scoprirai prima di chiunque altro l’ora d’inizio degli eventi Riscatta le ricompense EcoCredits.',
    redeem_ecocredits_rules_desc3:
        '2. Aumenta i tuoi EcoCredits: Durante ogni evento pop-up, potrai usufruire di uno sconto scambio punti fino al 50%. Ma sbrigati! Le quantità dei prodotti sono limitate. Ogni giorno, quattro prodotti unici verranno presentati nella promozione, ognuno dei quali sarà disponibili in un massimo di 100 unità.',
    points: 'EcoCredits',
    benefits_link_btn: 'Invita ora',
    network_error: 'Errore di rete',
    confirm_text: 'Riscattare i EcoCredits? Questa azione non può essere annullata.',
    manually_deducted: 'Detratti manualmente',
    redeeming_points: 'RISCATTARE I EcoCredits',
    earning_points: 'GUADAGNARE EcoCredits',
    confirm_btn: 'Conferma',
    faq_title: 'Domande frequenti',
    no_enough_points: 'Riscossione non riuscita, non hai abbastanza EcoCredits',
    no_history_note: 'Non vedi ancora i tuoi EcoCredits? La tua attività verrà aggiornata entro le 24 ore.',
    no_coupon_note: 'Nessun premio riscattato ancora.',
    minimum_price: 'Importo minimo di acquisto ({price}).',
    minimum_num: 'Quantità minima di articoli ({num} pezzi).',
    stay_too_long: 'La tua sessione è scaduta. Si prega di ricaricare la pagina e riprovare.',
    order_rule: "Un solo codice sconto per un'ordine.",
    purchas_rule: "Se il costo dell'articolo è inferiore dei coupon, la differenza andrà persa.",
    profile_birthday: 'Profilo - Data di nascita',
    profile_address: 'Profilo - Indirizzo',
    profile_username: 'Profilo - Nome',
    profile_picture: 'Profilo - Foto',
    profile_contact: 'Profilo - Informazioni di contatto',
    membership_faq_title: 'PROGRAMMA FEDELTÀ',
    learn_more: 'Ulteriori informazioni',
    profile_detail:
        "Completa il tuo profilo per guadagnare un massimo di 1000 EcoCredits, inclusa la foto del profilo (200), il nome utente (100), le informazioni di contatto (300), l'indirizzo (200) e il compleanno (200).",
    exceeded_counts: 'Non è stato possibile riscattare. È stato superato il limite di riscatto.',
    grab_title: 'Ottieni il bonus EcoCredits',
    grab_sub_title: 'Offerte esclusive a tempo limitato per i membri di EcoCredit. Clicca per reclamare il bonus ora',
    grab_btn_text: 'Prendi il mio bonus',
    grab_success_title: 'Congratulazioni',
    grab_success_text1: 'Bonus richiesto con successo!\n Incolla il codice alla cassa per ottenere lo sconto.',
    grab_success_text2: 'Controlla i tuoi bonus in <code>I miei premi</code>.',
    'no-grab-content-note': 'Ulteriori offerte in arrivo!',
    copy_desc: 'Hai copiato il codice, vai nel negozio per utilizzarlo.',
    copy_desc_2: 'Hai copiato il codice.',
    city_validatino_error: 'Città non valido',
    product_text: 'Prodotto',
    shipping_address_text: "L'indirizzo di spedizione",
    saved_address_text: 'Indirizzi salvati',
    use_new_address: 'Utilizza un nuovo indirizzo',
    spend_now: 'Spendi ora',
    stock_left: '{stock} Rimasti',
    no_stock_tip: 'Prossimamente... Rimani sintonizzato',
    order_text: 'Ordine',
    campaign_time_limit_text: 'Periodo di riscatto valido: {startTime} - {endTime}.',
    event_action_text: 'Attività',
    warranty_minus_action_text: 'Garanzia eliminata',
    question_correctly: 'Rispondi correttamente alla domanda',
    referral_correctly: 'rogramma di referral',
    confirm_btn_text: 'Chiudi',
    lucky_turntable_title: 'Giro fortunato',
    lucky_turntable_title2: 'Estrazione fortunata',
    join_lucky_with_points: 'Un giro fortunato costa {points} EcoCredit.',
    join_lucky_with_points2: 'Giocare una mano costa {points} EcoCredits.',
    join_lucky_desc: 'Gira la ruota e vinci un premio! ',
    remaining_number: 'Ancora <code></code> tentativi',
    remaining_number2: '<code></code> tentativi rimasti',
    learn_lucky_rule: 'Ulteriori informazioni sulle regole',
    prize_coupon_title: 'Congratulazioni',
    prize_coupon_sub_title: 'Il premio è stato richiesto correttamente! Utilizza questo codice al momento del pagamento per risparmiare.',
    prize_coupon_action: 'Controlla i tuoi premi in <code>I miei premi</code>.',
    prize_coupon_button: 'Acquista ora',
    prize_points_title: 'Congratulazioni',
    prize_points_desc: 'Controlla gli EcoCredits appena aggiunti in <code>Le mie attività</code>.',
    limit_times_in_day: 'Puoi girare la ruota per <count></count> volte in <day></day> giorni',
    limit_times_in_day2: 'Puoi girare le carte <count></count> volte in <day></day> giorni',
    limit_times_in_active: 'Durante l’evento, puoi girare la ruota fino a <count></count> volte.',
    limit_times_in_active2: 'Durante l’evento, puoi girare le carte fino a <count></count> volte.',
    without_limit_times: 'Puoi girare la ruota <count></count> volte in qualsiasi momento.',
    without_limit_times2: 'Puoi girare le carte <count></count> volte in qualsiasi momento.',
    active_is_unstart: 'Questo evento inizierà a breve.',
    active_is_ended: 'Questo evento è terminato.',
    over_max_count: 'Hai superato il numero di giri a disposizione.',
    notice_title: 'Avviso',
    members_nav: 'Prezzi per membri',
    referral_nav: 'Invita un amico',
    points_cash: 'Riscatto Punti',
    Pending1: 'In Sospeso',
    rollback: 'Restituito',
    product_hot_title: 'Imperdibili del momento',
    product_hot_desc: 'Non perdere l’occasione: acquista ora per beneficiare di regali esclusivi e sconti imbattibili!',
    product_refurbished_title: 'Prodotti ricondizionati – Approfitta di offerte ancora più vantaggiose per un periodo di tempo limitato!',
    product_refurbished_desc: 'Dalle 09:00 (CEST) del 17/10/2024 alle 08:59 (CEST) del 28/10/2024',
    level_change_log: 'Attività livelli',
    deadline: 'Valido fino a',
    history_refresh_member: 'Livello attuale: cliente',
    history_refresh_plus_member: 'Livello attuale: cliente PLUS',
    register: 'Iscriviti come membro',
    upgrade: 'Passa al livello PLUS',
    demotion: 'Effettua il downgrade al livello Cliente',
    relegation: 'Resta cliente PLUS',
    wattayear_2024: 'Condividi#WattAYear',
    site_account_profile_save_success: 'Inviata con successo',
    not_eligible: 'Non hai l’idoneità per partecipare a questo evento.',

    // FAQ
    faq_tab_all: 'Tutte le domande',
};
